angular.module('autoremind.directives')
    .directive('sideButtonPanel', function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            size: '@' // size can be (s - small, m - medium, l - large)
        },
        template: '<div class="sideBtnPanel" ng-transclude></div>',
        link: function (scope, elem, attr) {
            if (!angular.isDefined(scope.size) || (scope.size !== 's' && scope.size !== 'm' && scope.size !== 'l')) {
                scope.size = 'm';
            }
            elem.find(".sideBtnPanel").addClass(scope.size);
        }
    };
})
    .directive('sideBtn', function () {
    return {
        restrict: 'E',
        template: '<button class="btn btn-primary" ng-class="{\'btn-right-open\': open}" ng-disabled="disabled" ng-click="click()"><i class="glyphicon {{icon}}"></i>&nbsp;&nbsp;&nbsp;{{title}}</button>',
        scope: {
            click: '&',
            open: '=',
            disabled: '=',
            title: '@',
            icon: '@'
        }
    };
});
//# sourceMappingURL=side.panel.directives.js.map